import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { streamConvoAI } from '../../../provider/prompt-requests/convo-ai';
import { streamXPGenAI } from '../../../provider/prompt-requests/xp-gen-ai';
import { Icon } from '../../assets/icons/brainstorm';
import { createInsertAtCurrentPosition } from '../../config-item-actions/markdown';
import { messages } from './messages';
var SELECTION_TYPE = 'empty';
export var brainstormConfigItem = createEditorPluginAIConfigItemMarkdown({
  key: CONFIG_ITEM_KEYS.BRAINSTORM,
  title: messages.title,
  description: messages.description,
  selectionType: SELECTION_TYPE,
  getInitialContext: function getInitialContext(_ref) {
    var intl = _ref.intl;
    return {
      userLocale: intl.locale,
      intentSchemaId: 'brainstorm_intent_schema.json',
      document: ''
    };
  },
  promptLabel: messages.promptLabel,
  promptHint: messages.promptHint,
  icon: function icon(_ref2) {
    var shownAt = _ref2.shownAt;
    return /*#__PURE__*/React.createElement(Icon, {
      shownAt: shownAt
    });
  },
  triggerPromptRequest: function triggerPromptRequest(_ref3) {
    var initialContext = _ref3.initialContext,
      promptInput = _ref3.promptInput,
      editorSchema = _ref3.editorSchema,
      analyticsContext = _ref3.analyticsContext;
    if (fg('platform_editor_ai_assistance_service')) {
      return streamConvoAI({
        aiSessionId: analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.aiSessionId,
        customPrompt: promptInput,
        userLocale: initialContext.userLocale,
        intentSchemaId: 'brainstorm_intent_schema.json',
        editorSchema: editorSchema,
        currentSelection: initialContext.document
      });
    }
    return streamXPGenAI({
      customPrompt: promptInput,
      userLocale: initialContext.userLocale,
      intentSchemaId: 'brainstorm_intent_schema.json',
      editorSchema: editorSchema,
      contextList: [{
        type: 'text',
        entity: '',
        relationship: undefined
      }]
    });
  },
  isVisible: function isVisible() {
    return true;
  },
  actions: [createInsertAtCurrentPosition({
    appearance: 'primary'
  })],
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
});